import { forwardRef, type Ref, type SVGProps } from "react";
const IconBatteryLowOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 11.71h-2V8a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h23a1 1 0 0 0 1-1v-3.71h2a1 1 0 0 0 1-1v-5.58a1 1 0 0 0-1-1M25 22H4V9h21zm3-4.71h-1v-3.58h1Z" />
    <path d="M6 11h2v9H6z" />
  </svg>
);
const ForwardRef = forwardRef(IconBatteryLowOutlineSVG);
ForwardRef.displayName = "IconBatteryLowOutline";
export { ForwardRef as IconBatteryLowOutline };
